module.exports = __webpack_public_path__ + "img/design-tool.8ed98909.svg";